export default "__VITE_ASSET__BBOZbMbF__"